<template>
  <!-- 复制报价弹框 -->
  <div class="copy-dialog-style">
    <el-dialog
      title="Quotation"
      :visible="copyDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialog"
      :width="'800px'"
    >
      <div v-loading="isLoading">
        <div class="main-info copyValue">
          <div class="logo-info">
            <div>
              <img
                class="logo-img"
                v-if="!companyLogoImg"
                :src="$apiFileCloud + '/' + $apiFileCloudFirst + '/AttachForever/logo/freightshoplogo.png'"
                style="width: 201px;
                      height: 35px;
                      max-width: 100%;
                      max-height: 100%;
                      object-fit: contain;
                      border-radius: 4px;"
              />
              <img
                v-else
                class="logo-img"
                :src="$apiFileCloud + '/' + companyLogoImg"
                alt="logo"
                style="width: 201px;
                      height: 35px;
                      max-width: 100%;
                      max-height: 100%;
                      object-fit: contain;
                      border-radius: 4px;"
              />
            </div>
            <div :class="{ 'item-info': true, 'item-info-first': true }">
              {{ CompyInfo.CustomerName }}
            </div>
            <div :class="{ 'item-info': true, 'item-info-first': false }">
              Office Address：{{ getAddrsee }}
            </div>
            <div :class="{ 'item-info': true, 'item-info-first': false }">
              EMAIL：{{ UserInfo.Mail }}
            </div>
          </div>

          <div style="font-size: 14px; font-family: Times New Roman">
            <div class="option-style">
              <br />
              <div class="item-first-style" style="font-weight: 700">
                Quote Based On:
              </div>
              <div
                class="item-first-style item-top"
                style="font-weight: 700; text-decoration: underline"
              >
                {{
                  channelList.length > 0 ? channelList[0].volumeUnit : ""
                }}Cartons / GW.
                {{ channelList.length > 0 ? channelList[0].sumKG : "" }}Kgs /
                {{ channelList.length > 0 ? channelList[0].sumCBM : "" }}cbm (
                CW.
                {{
                  channelList.length > 1 ? channelList[1].AirChargeWeight : ""
                }}
                Kgs）
              </div>
              <div class="item-style">
                Incoterms:
                {{
                  channelList.length > 0
                    ? channelList[0].incotermsValue == 5
                      ? channelList[0].CityNameEn
                        ? "FOB (" + channelList[0].CityNameEn + ")"
                        : "FOB"
                      : channelList[0].incotermsValue == 6
                      ? "EXW"
                      : channelList[0].CityNameEn
                      ? "FCA (" + channelList[0].CityNameEn + ")"
                      : "FCA"
                    : ""
                }}
              </div>
              <div class="item-style">
                Our quotation based on density：<span
                  style="font-weight: 600"
                  >{{
                    channelList.length > 0 ? channelList[0].proportion : ""
                  }}</span
                >
              </div>
            </div>

            <!-- <div
            v-for="(item, index) in channelList.slice(1)"
            :key="index"
            class="option-top-1"
          >
            <div class="op-style">
              <br />
              <div class="title item-first-style" style="font-weight: 700">
                Option{{ index + 1 }}：
              </div>
              <br />
            </div>
            <div class="option-style item-title-style">
              <div class="info">
                By {{ item.AirCompanyCode2 }},
                <span v-if="item.AirTracficFee"
                  >USD{{ Number(item.AirPrice).toFixed(2) }}/Kg</span
                >, Routing: {{ item.FlightCourse }}, Frequency: Weekly{{
                  item.Flight
                }}, T/T: {{ item.ValidTerm
                }}{{ item.ValidTerm != 1 ? "Days" : "Day" }}
              </div>
            </div>

            <div
              class="option-style item-title-style"
              v-if="item.LstAirFee.length > 0 || item.THAmount > 0"
            >
              <div class="title" style="font-weight: 700">Local Charge:</div>
              <div class="info">
                <div v-for="(items, indexs) in item.LstAirFee" :key="indexs">
                  {{ items.FeeNameEn }}: USD{{
                    Number(items.UnitPrice).toFixed(2)
                  }}/{{ getUnit(items.Unit) }}
                  <span v-if="items.MinValue"
                    >(Min US${{ Number(items.MinValue).toFixed(2) }})</span
                  >
                </div>
                <div v-if="item.THAmount > 0">
                  Pickup Charge: USD{{ Number(item.THAmount).toFixed(2) }}/Bill
                  <span
                    >({{ item.ThWorkDay
                    }}{{ item.ThWorkDay != 1 ? "Days" : "Day" }})</span
                  >
                </div>
              </div>
            </div>
            <div class="option-style item-title-style" v-if="item.Clause">
              <div class="title">Remark:</div>
              <div class="info">
                <div v-html="item.Clause.replace(/(\r\n)|(\n)/g, '<br>')"></div>
              </div>
            </div>
          </div> -->

            <!-- 新 -->
            <div
              class="option-item"
              v-for="(item, index) in channelList.slice(1)"
              :key="index"
            >
              <div
                class="option-item-top"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding-bottom: 8px;
                "
              >
                <div
                  class="option-item-top__title"
                  style="
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 22px;
                    font-style: normal;
                  "
                >
                  Option{{ index + 1 }}：
                </div>
                <span
                  class="option-item-top__right"
                  style="display: inline-block"
                >
                  <template v-if="!item.IsEdit">
                    <button
                      type="button"
                      class="option-item-edit__button"
                      v-if="isShowEdit"
                      @click="editPrice(item)"
                    >
                      <img
                        style="display: inline-block"
                        src="../../../assets/img/saveQuotes/editPrice@2x.png"
                        width="16"
                        height="16"
                        alt="edit"
                      />
                      <span>Edit Price</span>
                    </button>
                  </template>

                  <template v-else>
                    <button
                      type="button"
                      class="option-item-reset__button"
                      @click="resetPrice(item, index + 1)"
                    >
                      <span>Reset</span>
                    </button>

                    <button
                      style="margin-left: 4px"
                      type="button"
                      class="option-item-submit__button"
                      @click="submitPrice(item)"
                    >
                      <span>Save</span>
                    </button>
                  </template>
                </span>
              </div>

              <div class="option-item-header">
                <span
                  class="option-item-label"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 22px;
                    font-style: normal;
                  "
                >
                  By {{ item.AirCompanyCode2 }}，
                </span>
                <template v-if="item.AirTracficFee">
                  <span
                    class="option-item-label"
                    style="
                      font-weight: 400;
                      font-size: 13px;
                      line-height: 22px;
                      font-style: normal;
                    "
                    >USD</span
                  >
                  <span
                    class="option-item-label"
                    v-if="!item.IsEdit"
                    style="
                      font-weight: 400;
                      font-size: 13px;
                      line-height: 22px;
                      font-style: normal;
                    "
                  >
                    &nbsp;{{ Number(item.AirPrice).toFixed(2) }}/Kg，
                  </span>
                  <div class="reset-el-input-number" v-else>
                    <el-input-number
                      size="mini"
                      v-model="item.AirPrice"
                      :precision="2"
                      :step="0.01"
                    ></el-input-number>
                    <span
                      class="option-item-label"
                      style="
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 22px;
                        font-style: normal;
                      "
                    >
                      /Kg，
                    </span>
                  </div>
                </template>
                <span
                  class="option-item-label"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 22px;
                    font-style: normal;
                  "
                  >Routing：</span
                >
                <span
                  class="option-item-text"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 22px;
                    font-style: normal;
                  "
                  >&nbsp;{{ item.FlightCourse }}，</span
                >

                <span
                  class="option-item-label"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 22px;
                    font-style: normal;
                  "
                  >Frequency：</span
                >
                <span
                  class="option-item-text"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 22px;
                    font-style: normal;
                  "
                  >&nbsp;Weekly{{ item.Flight }}，</span
                >

                <span
                  class="option-item-label"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 22px;
                    font-style: normal;
                  "
                  >T/T:</span
                >
                <span
                  class="option-item-text"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 22px;
                    font-style: normal;
                  "
                >
                  &nbsp;{{ item.ValidTerm
                  }}{{ item.ValidTerm != 1 ? "Days" : "Day" }}
                </span>
              </div>

              <div
                class="option-item-main"
                v-if="item.LstAirFee.length > 0 || item.THAmount > 0"
              >
                <div
                  class="option-item-main__title"
                  style="
                    margin-top: 8px;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 22px;
                    text-align: left;
                    font-style: normal;
                  "
                >
                  Local Charge：
                </div>
                <div
                  class="option-item-item"
                  v-for="(items, indexs) in item.LstAirFee"
                  :key="indexs"
                >
                  <span
                    class="option-item-item__label"
                    style="
                      display: inline-block;
                      font-weight: 400;
                      font-size: 13px;
                      line-height: 18px;
                      text-align: left;
                      font-style: normal;
                    "
                  >
                    {{ items.FeeNameEn }}:&nbsp;
                  </span>
                  <span
                    class="option-item-item__text"
                    style="
                      display: inline-block;
                      font-weight: 400;
                      font-size: 13px;
                      line-height: 18px;
                      text-align: left;
                      font-style: normal;
                    "
                    >USD</span
                  >
                  <template>
                    <span
                      class="option-item-item__text"
                      style="
                        display: inline-block;
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 18px;
                        text-align: left;
                        font-style: normal;
                      "
                      v-if="!item.IsEdit"
                    >
                      {{ Number(items.UnitPrice).toFixed(2) }}/{{
                        getUnit(items.Unit)
                      }}
                    </span>
                    <div class="reset-el-input-number" v-else>
                      <el-input-number
                        size="mini"
                        v-model="items.UnitPrice"
                        :precision="2"
                        :step="0.01"
                      ></el-input-number>
                      <span
                        class="option-item-item__text"
                        style="
                          display: inline-block;
                          font-weight: 400;
                          font-size: 13px;
                          line-height: 18px;
                          text-align: left;
                          font-style: normal;
                        "
                      >
                        /{{ getUnit(items.Unit) }}
                      </span>
                    </div>
                  </template>

                  <template v-if="items.MinValue">
                    <span
                      class="option-item-item__text"
                      style="
                        display: inline-block;
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 18px;
                        text-align: left;
                        font-style: normal;
                      "
                      >(Min US$</span
                    >
                    <template>
                      <span
                        v-if="!item.IsEdit"
                        class="option-item-item__text"
                        style="
                          display: inline-block;
                          font-weight: 400;
                          font-size: 13px;
                          line-height: 18px;
                          text-align: left;
                          font-style: normal;
                        "
                      >
                        {{ Number(items.MinValue).toFixed(2) }}
                      </span>
                      <div class="reset-el-input-number" v-else>
                        <el-input-number
                          size="mini"
                          v-model="items.MinValue"
                          :precision="2"
                          :step="0.01"
                        ></el-input-number>
                      </div>
                    </template>

                    <span
                      class="option-item-item__text"
                      style="
                        display: inline-block;
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 18px;
                        text-align: left;
                        font-style: normal;
                      "
                      >)</span
                    >
                  </template>
                </div>
                <div class="option-item-item" v-if="item.THAmount > 0">
                  <span
                    class="option-item-item__label"
                    style="
                      display: inline-block;
                      font-weight: 400;
                      font-size: 13px;
                      line-height: 18px;
                      text-align: left;
                      font-style: normal;
                    "
                    >Pickup Charge: &nbsp;</span
                  >
                  <span
                    class="option-item-item__text"
                    style="
                      display: inline-block;
                      font-weight: 400;
                      font-size: 13px;
                      line-height: 18px;
                      text-align: left;
                      font-style: normal;
                    "
                    >USD</span
                  >
                  <template>
                    <span
                      class="option-item-item__text"
                      style="
                        display: inline-block;
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 18px;
                        text-align: left;
                        font-style: normal;
                      "
                      v-if="!item.IsEdit"
                    >
                      {{ Number(item.THAmount).toFixed(2) }}/Bill ({{
                        item.ThWorkDay
                      }}{{ item.ThWorkDay != 1 ? "Days" : "Day" }})
                    </span>
                    <div class="reset-el-input-number" v-else>
                      <el-input-number
                        size="mini"
                        v-model="item.THAmount"
                        :precision="2"
                        :step="0.01"
                      ></el-input-number>
                      <span
                        class="option-item-item__text"
                        style="
                          display: inline-block;
                          font-weight: 400;
                          font-size: 13px;
                          line-height: 18px;
                          text-align: left;
                          font-style: normal;
                        "
                        >/Bill ({{ item.ThWorkDay
                        }}{{ item.ThWorkDay != 1 ? "Days" : "Day" }})
                      </span>
                    </div>
                  </template>
                </div>
              </div>
              <div class="option-style item-title-style" v-if="item.Clause">
                <div class="title">Remark:</div>
                <div class="info">
                  <div
                    v-html="item.Clause.replace(/(\r\n)|(\n)/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">Not now</el-button>
          <el-button type="primary" @click="importPriceValid"
            >Download</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post, fetch, Del, put } from "@/ask/axios";
import { fileSteamDownload } from "@/utils/download";
export default {
  data() {
    return {
      copyDialogValue: false,
      logoInfo: [
        // {
        //   title: "Website",
        //   value: "www.freightshop.com",
        // },
        {
          title: "Freightshop Technology Co.,Ltd | WCA ID",
          value: "109570",
        },
        {
          title: "Office Address",
          value:
            "A World Trade Plaza Fuhong Rd Futian District -ShenZhen City China.",
        },
        {
          title: "EMAIL",
          value: "Support@freightshop.com",
        },
      ],
      topInfo: [
        {
          title: "Quote Based On",
          value: "598Cartons / GW. 2338kgs / 16.17cbm ( CW. 2695 kgs）",
        },
        {
          title: "Incoterms",
          value: "EXW",
        },
        {
          title: "Our quotation based on density 1:500",
          value: "",
        },
      ],
      channelList: [],
      channelListSub: [],
      isLoading: false,
      isShowEdit: true,
      countryOptions: [], //海外国家下拉数据
      companyLogoImg: "",
      UserInfo: {},
      CompyInfo: {},
    };
  },
  props: {
    copyDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    copyPriceData: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    copyPriceList: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    copyDialog(val) {
      //console.log(val);
      this.copyDialogValue = val;
    },
    copyPriceData: {
      handler(val) {
        // this.channelList = val;
        console.log(val, "copyPriceData");
        let channelList = JSON.parse(JSON.stringify(val));

        channelList.forEach((item, index) => {
          if (index > 0) {
            this.$set(item, "IsEdit", false);
            // 单价
            this.$set(item, "AirPrice", Number(item.AirPrice).toFixed(2));
            // 本地费
            if (item.LstAirFee.length > 0) {
              item.LstAirFee.forEach((items) => {
                this.$set(
                  items,
                  "UnitPrice",
                  Number(items.UnitPrice).toFixed(2)
                );
                if (items.MinValue) {
                  this.$set(
                    items,
                    "MinValue",
                    Number(items.MinValue).toFixed(2)
                  );
                }
              });
            }
            // 取件费
            if (item.THAmount > 0) {
              this.$set(item, "THAmount", Number(item.THAmount).toFixed(2));
            }
          }
        });
        this.channelList = channelList;
        this.channelListSub = JSON.parse(JSON.stringify(channelList));
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    getAddrsee() {
      let ProvincesName = "";
      let PostCode = "";
      let CountryName = "";
      let AddressInfo = "";
      let CityName = "";
      // this.countryOptions.forEach((element) => {
      //   if (element.CountryKey === this.CompyInfo.CountryKey) {
      //     CountryName = element.NameEn;
      //   }
      // });
      CountryName = this.CompyInfo.Country;
      if (!this.CompyInfo.ProvincesName) {
        ProvincesName = "";
      } else {
        ProvincesName = this.CompyInfo.ProvincesName + ", ";
      }
      if (!this.CompyInfo.PostCode) {
        PostCode = "";
      } else {
        PostCode = this.CompyInfo.PostCode + ", ";
      }
      if (!this.CompyInfo.AddressInfo) {
        AddressInfo = "";
      } else {
        AddressInfo = this.CompyInfo.AddressInfo + ", ";
      }
      if (!this.CompyInfo.CityName) {
        CityName = "";
      } else {
        CityName = this.CompyInfo.CityName + ", ";
      }
      return AddressInfo + CityName + ProvincesName + PostCode + CountryName;
    },
  },
  async mounted() {
    await this.getUserInfo();
    await this.GetUsercompy();
  },
  methods: {
    getUserInfo() {
      let url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      post(url, {}).then((res) => {
        if (res.Results) {
          this.UserInfo = res.Results;
          // 判断是否有公司logo
          if (res.Results.CompanyLogoImg) {
            this.companyLogoImg = res.Results.CompanyLogoImg;
          }
        }
      });
    },
    GetUsercompy() {
      let url = this.$api02 + "/api/EbayCustomer/CustomerInfo/GetUserInfo";
      let param = {};
      fetch(url, param).then((res) => {
        if (res.Results) {
          // 公司信息
          this.CompyInfo = res.Results;
          this.UserInfo.IsMailVerify = res.Results.IsMailVerify;
        }
      });
    },

    // 修改价格
    editPrice(item) {
      this.$set(item, "IsEdit", true);
    },
    // 重置价格
    resetPrice(itemParent, indexParent) {
      this.$set(itemParent, "IsEdit", false);
      let channelItem = JSON.parse(
        JSON.stringify(this.channelListSub[indexParent])
      );
      let channelList = this.channelList;
      channelList.forEach((item, index) => {
        if (indexParent == index) {
          this.$set(item, "IsEdit", false);
          // 单价
          this.$set(item, "AirPrice", Number(channelItem.AirPrice).toFixed(2));
          // 本地费
          if (item.LstAirFee.length > 0) {
            this.$set(item, "LstAirFee", channelItem.LstAirFee);
            item.LstAirFee.forEach((items) => {
              this.$set(items, "UnitPrice", Number(items.UnitPrice).toFixed(2));
              if (items.MinValue) {
                this.$set(items, "MinValue", Number(items.MinValue).toFixed(2));
              }
            });
          }
          // 取件费
          if (item.THAmount > 0) {
            this.$set(
              item,
              "THAmount",
              Number(channelItem.THAmount).toFixed(2)
            );
          }
        }
      });
      this.channelList = channelList;
    },
    submitPrice(item) {
      this.$set(item, "IsEdit", false);
    },
    getUnit(unit, isBill) {
      // 计费单位 目的地费用:（0：票，1：CBM，2：份，3：KG,4：页，5：单,6：天，7：次，8：件）
      switch (unit) {
        case 0:
          // if(isBill) {
          return "Bill";
        // }
        // return 'b\\l'
        case 1:
          return "cbm";
        case 2:
          return "pcs";
        case 3:
          return "Kg";
        case 4:
          return "page";
        case 5:
          // if(isBill) {
          return "Bill";
        // }
        // return 'b\\l'
        case 6:
          return "Day";
        case 7:
          return "Time";
        case 8:
          return "Unit";
      }
    },
    closeDialog() {
      // 关闭弹框
      this.$emit("closeCopyDialog", false);
    },
    encodeHtml(str) {
      var encodedStr = "";
      if (str == "") return encodedStr;
      else {
        for (var i = 0; i < str.length; i++) {
          encodedStr +=
            "&#" +
            str
              .substring(i, i + 1)
              .charCodeAt()
              .toString(10) +
            ";";
        }
      }
      return encodedStr;
    },
    htmlEscape(text) {
      return text.replace(/[<>"&]/g, function (match, pos, originalText) {
        switch (match) {
          case "<":
            return "&lt;";
          case ">":
            return "&gt;";
          case "&":
            return "&amp;";
          case '"':
            return "&quot;";
        }
      });
    },

    HTMLDecode(html) {
      var temp = document.createElement("div");
      temp.textContent != undefined
        ? (temp.textContent = html)
        : (temp.innerText = html);
      var output = temp.innerHTML;
      temp = null;
      return output;
    },
    escape2Html(str) {
      var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    importPriceValid() {
      this.isShowEdit = false;
      // 验证是否都保存了
      let isAllSave = false;
      isAllSave = this.channelList
        .slice(1)
        .every((item) => item.IsEdit == false);
      if (!isAllSave) {
        this.$confirm(
          "Detected unsaved quotation, do you want to save and download it?",
          "Tips",
          {
            distinguishCancelAndClose: true,
            customClass: "customClassConfirm",
            cancelButtonText: "Save original price",
            confirmButtonText: "Yes",
            type: "warning",
          }
        )
          .then(() => {
            this.channelList.forEach((item, index) => {
              if (index > 0) {
                this.$set(item, "IsEdit", false);
              }
            });
            this.isLoading = true;
            let timeout = setTimeout(() => {
              this.isLoading = false;
              this.importPrice();
              clearTimeout(timeout);
              timeout = null;
            }, 3000);
          })
          .catch((action) => {
            if (action == "cancel") {
              this.channelList.forEach((item, index) => {
                if (index > 0 && item.IsEdit) {
                  this.resetPrice(item, index);
                }
              });
              this.isLoading = true;
              let timeout = setTimeout(() => {
                this.isLoading = false;
                this.importPrice();
                clearTimeout(timeout);
                timeout = null;
              }, 3000);
            }
          });
      } else {
        this.isLoading = true;
        let timeout = setTimeout(() => {
          this.isLoading = false;
          this.importPrice();
          clearTimeout(timeout);
          timeout = null;
        }, 3000);
      }
    },
    // 判断是否有未保存的
    async importPrice() {
      let html1 = document.getElementsByClassName("copyValue")[0].outerHTML;

      const url =
        this.$api04 + "/Air/api/AirQueryPriceStore/ImportHtmlPriceStore";

      let param = {
        htmlstring: this.escape2Html(this.htmlEscape(html1))
          .replaceAll("&quot;;", "")
          .replaceAll("&quot;", ""),
      };
      const data = await post(url, param);

      if (data.IsOK && data.Results.IsData) {
        this.isShowEdit = true;
        // 正式环境加File前缀
        // let url = this.$apiEn == 'https://freightshop.com/' ? this.$apiFileCloud + '/File' : this.$apiFileCloud;

        // 关闭弹框

        let url = this.$apiFileCloud + "/" + data.Results.Path;
        let nameList = data.Results.Path.split("/");

        fileSteamDownload(
          this,
          {
            FullPath: url, // 路径
            CurrentFileName: nameList[nameList.length - 1], // 文件名称
          },
          "Air Quotation.doc"
        );
        this.$emit("closeCopyDialog", 0);
      }
    },
  },
};
</script>

<style lang="less">
.op-style {
  border-bottom: 1px dashed #e6e6e6;
  color: #333333;
}
.copy-dialog-style {
  .el-dialog {
    background: #ffffff;
    box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.25);
    border-radius: 10px;

    .el-dialog__header {
      margin: 0 15px;
      padding: 10px 0;
      border-bottom: 1px solid #e6e6e6;
    }

    .el-dialog__body {
      padding: 0px 0px 0px 15px;
      margin-right: 3px;
      margin-bottom: 2px;
      height: 400px;
      overflow-y: auto;
    }

    .el-dialog__footer {
      // padding: 0 20px 30px 20px;
      position: relative;
      bottom: 0;
      height: 60px;
      box-shadow: 0px -2px 6px 0px rgba(0, 0, 0, 0.1);
    }

    .el-icon-close {
      font-weight: bold;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #333333;
    }
  }

  .main-info {
    //  height: 400px;
    //  overflow-y: auto;
    padding-right: 8px;
    padding-bottom: 60px;

    .logo-info {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding-bottom: 15px;
      padding-top: 15px;
      border-bottom: 1px dashed #e6e6e6;

      .logo-img {
        width: 201px;
        height: 35px;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 4px;
      }

      .item-info {
        font-size: 13px;
        font-family: "MicrosoftYaHei";
        color: #777777;
        line-height: 17px;
        margin-top: 5px;
      }

      .item-info-first {
        margin-top: 10px;
      }
    }

    .option-style {
      padding: 10px 0;
      border-bottom: 1px dashed #e6e6e6;

      .item-style {
        margin-top: 5px;
        font-size: 13px;
        font-family: "MicrosoftYaHei";
        color: #777777;
        line-height: 17px;
      }

      .item-first-style {
        font-size: 14px;
        font-family: "MicrosoftYaHei";
        color: #333333;
        line-height: 19px;
      }

      .item-top {
        margin-top: 5px;
      }
    }

    .item-title-style {
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      line-height: 19px;

      .title {
        color: #333333;
      }

      .info {
        color: #777777;
      }

      .info-flex {
        //  display: grid;
        grid-template-columns: 1fr 1fr;
      }
    }

    .option-top {
      padding-bottom: 15px;
      font-weight: 600;
    }

    .option-top-1 {
      padding-top: 15px;
    }

    .item-list-title-style {
      padding: 10px 0;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      color: #333333;
      line-height: 19px;
    }

    .border-bootom-title {
      font-weight: 700;
      border-bottom: 1px dashed #e6e6e6;
    }

    .option-item {
      padding: 8px;
      background: #f7f8fa;
      border-radius: 4px;
      border: 1px solid transparent;
      box-sizing: border-box;
      transition: all 0.2s;

      &:hover {
        border: 1px solid rgba(0, 79, 177, 0.4);
      }
      .option-item-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 8px;
        .option-item-top__title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #333333;
          line-height: 22px;
          font-style: normal;
        }

        .option-item-top__right {
          .option-item-edit__button {
            cursor: pointer;
            outline: none;
            border: none;
            width: 90px;
            height: 24px;
            background: rgba(0, 79, 177, 0);
            border-radius: 4px;
            transition: all 0.2s;

            &:hover {
              background: rgba(0, 79, 177, 0.08);
            }

            img {
              position: relative;
              top: 2px;
            }

            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 13px;
              color: #004fb1;
              line-height: 18px;
              text-align: left;
              font-style: normal;
            }
          }

          .option-item-reset__button {
            cursor: pointer;
            outline: none;
            border: none;
            // width: 48px;
            padding: 2px 4px;
            height: 24px;
            background: rgba(0, 79, 177, 0);
            border-radius: 4px;
            border: 1px solid #004fb1;
            box-sizing: border-box;

            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 13px;
              color: #004fb1;
              line-height: 18px;
              font-style: normal;
            }
          }

          .option-item-submit__button {
            cursor: pointer;
            outline: none;
            border: none;
            // width: 60px;
            padding: 2px 4px;
            height: 24px;
            background: #004fb1;
            border-radius: 4px;
            box-sizing: border-box;

            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 13px;
              color: #ffffff;
              line-height: 18px;
              font-style: normal;
            }
          }
        }
      }

      .option-item-header {
        display: flex;
        align-items: center;
        height: 40px;
        border: 1px dashed #e6e6e6;
        border-left: none;
        border-right: none;
        box-sizing: border-box;

        .option-item-label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #777777;
          line-height: 22px;
          font-style: normal;
        }

        .option-item-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #333;
          line-height: 22px;
          font-style: normal;
        }

        .option-item-line {
          margin: 0 8px;
          width: 1px;
          height: 13px;
          background: #777;
        }
      }

      .option-item-main {
        .option-item-main__title {
          margin-top: 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #333333;
          line-height: 22px;
          text-align: left;
          font-style: normal;
        }

        .option-item-item {
          display: flex;
          align-items: center;
          height: 36px;
          background: transparent;
          transition: all 0.2s;

          &:hover {
            background: #f7f8fa;
          }

          .option-item-item__label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #777777;
            line-height: 18px;
            text-align: left;
            font-style: normal;
          }

          .option-item-item__text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #333333;
            line-height: 18px;
            text-align: left;
            font-style: normal;
          }
        }
      }
    }
  }

  // .scrollbar{
  //   width: 30px;
  //   height: 300px;
  //   margin: 0 auto;
  // }

  .message-info {
    font-size: 14px;
    font-family: "MicrosoftYaHei";
    text-align: center;
    color: #333333;
    line-height: 19px;
  }

  .dialog-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 15px;
    z-index: 222;
    width: 770px;
    background: #fff;

    display: flex;
    justify-content: center;

    .el-button {
      width: 109px;
      height: 30px;
      border-radius: 100px;
      font-size: 12px;
      line-height: 6px;
      font-family: "MicrosoftYaHei";
    }

    .el-button--default {
      color: #004fb1;
      border: 1px solid #004fb1;
    }

    .el-button--primary {
      background: #004fb1;
    }
  }
}

.reset-el-input-number {
  .el-input-number {
    margin: 0 4px;
    .el-input-number__increase {
      background: #f5f7fa;
      color: #606266;
    }
  }
}

.customClassConfirm {
  padding-bottom: 24px;
  .el-message-box__header {
    height: 56px;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    box-sizing: border-box;

    .el-message-box__title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }

    .el-message-box__close {
      &:hover {
        color: #0046b9;
      }
    }
  }

  .el-message-box__content {
    padding: 16px 24px;
    .el-message-box__message {
      padding: 0 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
    }

    .el-message-box__status {
      font-size: 16px !important;
    }
  }

  .el-message-box__btns {
    .el-button--default {
      min-width: 120px;
      height: 32px;
      background: rgba(255, 255, 255, 0);
      border-radius: 4px;
      border: 1px solid rgba(0, 79, 177, 0);

      span {
        color: #0046b9;
      }

      &:hover,
      &:active {
        border-color: #0046b9 !important;
      }
    }

    .el-button--primary {
      min-width: 48px;
      height: 32px;
      background: #004fb1;
      border-radius: 4px;
      border: 1px solid #0046b9;
      background: #0046b9 !important;

      &:hover,
      &:active {
        border-color: transparent !important;
      }

      span {
        color: #fff !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/air/copyPriceDialog.vue